var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      class: {
        "platform-viewer": true,
        "platform-viewer--comparisonsQueued": _vm.chosenPlatforms.length
      }
    },
    [
      _c(
        "header",
        {
          class: [
            "platform-viewer__head",
            "platform-viewer__head--" + _vm.currentPlatform.status
          ]
        },
        [
          _c("p", { staticClass: "platform-viewer__status" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.platformStatus(_vm.currentPlatform.status)) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("h2", { staticClass: "platform-viewer__name" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.currentPlatform.displayName) + "\n    "
            )
          ]),
          _vm._v(" "),
          _vm.currentPlatform
            ? _c(
                "div",
                { staticClass: "platform-viewer__info" },
                [
                  _vm.currentPlatform.status !== "product_hosted" &&
                  this.currentRouteName !== "FinalSelection"
                    ? _c(
                        "unum-button",
                        {
                          attrs: {
                            small: "",
                            outline: "",
                            color: "leaf4",
                            hovered: _vm.isCurrentInCompare
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.tryTogglePlatform(_vm.currentPlatform)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.isCurrentInCompare
                                  ? "Added To Compare"
                                  : "Compare This"
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  this.currentRouteName !== "FinalSelection" &&
                  this.currentPlatform.status !== "product_hosted"
                    ? _c(
                        "unum-button",
                        {
                          attrs: {
                            id: "platform-viewer-next-steps-button",
                            small: "",
                            outline: "",
                            color: "blue"
                          },
                          nativeOn: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.viewFinal(_vm.currentPlatform)
                            }
                          }
                        },
                        [_vm._v("\n        Next Steps\n      ")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.currentPlatform.status !== "product_hosted"
        ? _c(
            "section",
            {
              class: [
                "feature-sections",
                {
                  "feature-sections--final-selection":
                    this.$route.name === "FinalSelection"
                }
              ]
            },
            [
              _vm._l(_vm.featureSections, function(section) {
                return _c(
                  "section",
                  {
                    key: section[".key"],
                    class: [
                      "feature-section",
                      "feature-section--" + section[".key"],
                      {
                        "feature-section--collapsed":
                          _vm.settings.featureCollapse[section[".key"]],
                        "print-hide":
                          section.displayName === "Pricing" ||
                          section.displayName === "Sales Contact" ||
                          section.displayName === "Propr Path"
                      }
                    ]
                  },
                  [
                    _c("div", { staticClass: "feature-section__head" }, [
                      _c(
                        "h3",
                        {
                          staticClass: "feature-section__title",
                          on: {
                            click: function($event) {
                              return _vm.toggleFeatureEvent(
                                section[".key"],
                                section.displayName,
                                _vm.settings.featureCollapse[section[".key"]]
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(section.displayName) +
                              "\n          "
                          ),
                          _c(
                            "span",
                            {
                              class: [
                                "button",
                                "button--blue",
                                "button--small",
                                "button--outline",
                                {
                                  "button--hover":
                                    _vm.settings.featureCollapse[
                                      section[".key"]
                                    ]
                                }
                              ]
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.settings.featureCollapse[
                                      section[".key"]
                                    ]
                                      ? "Show"
                                      : "Hide"
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "feature-section__body" }, [
                      _c("div", { staticClass: "table-wrapper" }, [
                        _c(
                          "table",
                          {
                            class: [
                              "features-table",
                              "features-table--" + section[".key"]
                            ]
                          },
                          _vm._l(_vm.sortFeatures(section.features), function(
                            feature
                          ) {
                            return _c("tr", { key: feature[".key"] }, [
                              _c(
                                "td",
                                { staticClass: "features-table__cell" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(feature.displayName) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.currentPlatform &&
                              _vm.currentPlatform.features
                                ? _c(
                                    "td",
                                    {
                                      staticClass: "features-table__cell-value"
                                    },
                                    [
                                      feature && feature.notesOnly
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "features-table__cell-value--notes-only"
                                              },
                                              [
                                                _vm.currentPlatform.features[
                                                  feature[".key"]
                                                ]
                                                  ? [
                                                      _c("span", {
                                                        staticClass:
                                                          "feature-note",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.currentPlatform
                                                              .features[
                                                              feature[".key"]
                                                            ].notes
                                                              ? _vm.currentPlatform.features[
                                                                  feature[
                                                                    ".key"
                                                                  ]
                                                                ].notes.trim()
                                                              : ""
                                                          )
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.handleClick(
                                                              $event
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ]
                                                  : _vm._e()
                                              ],
                                              2
                                            )
                                          ]
                                        : [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "features-table__cell-value--flex"
                                              },
                                              [
                                                _vm.currentPlatform.features[
                                                  feature[".key"]
                                                ]
                                                  ? [
                                                      _vm.currentPlatform
                                                        .features[
                                                        feature[".key"]
                                                      ].available === true
                                                        ? _c("unum-icon", {
                                                            attrs: {
                                                              icon: "check"
                                                            }
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.currentPlatform
                                                        .features[
                                                        feature[".key"]
                                                      ].available === null ||
                                                      _vm.currentPlatform
                                                        .features[
                                                        feature[".key"]
                                                      ].available === false
                                                        ? _c("unum-icon", {
                                                            attrs: {
                                                              icon: "x-gray"
                                                            }
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.currentPlatform
                                                        .features[
                                                        feature[".key"]
                                                      ].available === "unknown"
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "availability-unknown"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        Unknown\n                      "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.currentPlatform
                                                        .features[
                                                        feature[".key"]
                                                      ].notes
                                                        ? _c("unum-icon", {
                                                            directives: [
                                                              {
                                                                name: "tooltip",
                                                                rawName:
                                                                  "v-tooltip",
                                                                value:
                                                                  _vm.currentPlatform.features[
                                                                    feature[
                                                                      ".key"
                                                                    ]
                                                                  ].notes.trim() ||
                                                                  "",
                                                                expression:
                                                                  "currentPlatform.features[feature['.key']].notes.trim() || ''"
                                                              }
                                                            ],
                                                            attrs: {
                                                              icon: "info"
                                                            }
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.currentPlatform
                                                        .features[
                                                        feature[".key"]
                                                      ].notes
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "print-tooltip"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Note: " +
                                                                  _vm._s(
                                                                    _vm.currentPlatform.features[
                                                                      feature[
                                                                        ".key"
                                                                      ]
                                                                    ].notes.trim() ||
                                                                      ""
                                                                  )
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  : [
                                                      _c("unum-icon", {
                                                        attrs: {
                                                          icon: "x-gray"
                                                        }
                                                      })
                                                    ]
                                              ],
                                              2
                                            )
                                          ]
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ])
                          }),
                          0
                        )
                      ])
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _vm.currentPlatform.platformNotes
                ? _c(
                    "section",
                    { staticClass: "feature-section__special-programs" },
                    [
                      _c("h3", [_vm._v("Special Programs")]),
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.currentPlatform.platformNotes) +
                          "\n    "
                      )
                    ]
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0436f815", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0436f815","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PlatformViewer.vue
// module id = null
// module chunks = 